import type { ElementType } from 'react';
import { Cog6ToothIcon, GlobeAltIcon, LifebuoyIcon, PaperAirplaneIcon, SwatchIcon } from '@heroicons/react/24/outline';

export interface HubLink {
  name: string;
  href: string;
  description?: string;
  icon: ElementType;
  roles?: string[];
}

export interface NavHub {
  title: string;
  subtitle?: string;
  links: HubLink[];
}

// Section "hub" pages: a single sidebar link opens one of these, and the page
// renders the section's sub-links as cards (role-filtered) instead of showing
// them in the sidebar.
//
// The `quotes` hub was retired (C1): its three cards were "All Quotes" plus the
// New Quote and Batch Quotes actions that QuotesListPage already renders as
// header buttons, so it was a click between the sidebar and the list that added
// nothing. The sidebar now points straight at /quotes; a bookmarked
// /hub/quotes falls through NavHubPage's unknown-hub redirect to /dashboard.
export const NAV_HUBS: Record<string, NavHub> = {
  settings: {
    title: 'Settings',
    subtitle: 'Account and platform settings',
    links: [
      {
        name: 'General',
        href: '/settings',
        description: 'General account settings',
        icon: Cog6ToothIcon,
      },
      {
        name: 'Domain Settings',
        href: '/settings/domain',
        description: 'Configure your custom domain',
        icon: GlobeAltIcon,
        roles: ['broker_admin'],
      },
      {
        name: 'Branding',
        href: '/settings/branding',
        description: 'Logos, colours and theme',
        icon: SwatchIcon,
        roles: ['country_admin'],
      },
      // Boards #233 and #232 both referred to "Settings gateway config" as if
      // it existed. It did not -- this hub listed profile, domain and branding
      // and nothing else, which is why production has zero
      // CommunicationChannel rows and every email/SMS/WhatsApp send fails at
      // "no channel configured".
      {
        name: 'Communication Gateways',
        href: '/settings/gateways',
        description: 'Email, SMS and WhatsApp providers',
        icon: PaperAirplaneIcon,
        roles: ['super_admin', 'country_admin', 'broker_admin'],
      },
      {
        name: 'Support Categories',
        href: '/settings/support-categories',
        description: 'Categories for support tickets',
        icon: LifebuoyIcon,
        roles: ['super_admin', 'country_admin', 'broker_admin'],
      },
    ],
  },
};
